import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form,
} from '@angular/forms';
import { IOption } from 'src/app/interfaces/option';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AppFormat } from '../../appFormat';

import { OperadorService } from '../../services/operador.service';
import { HelperService } from 'src/app/services/helper.service';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss'],
  host: { class: 'wrapper-settings' },
})
export class PaymentMethodsComponent implements OnInit {
  public loading: boolean = false;

  public config_sys: boolean = false;

  public changed: boolean;
  public settingsFrm: FormGroup;

  // padrao

  public pagamento_local!: FormControl;
  public pagamento_entrega!: FormControl;
  public pagamento_online!: FormControl;

  public tipo!: FormControl;
  public code!: FormControl;
  public token!: FormControl;
  public limite_parcelamento_loja!: FormControl;
  public juro_parcelamento_loja!: FormControl;
  public limite_parcelamento_operadora!: FormControl;
  public juro_parcelamento_operadora!: FormControl;

  public parecela_minima!: FormControl;

  public payment_methods!: FormArray;

  public tipos_meio_pagamento: any[];
  public onde_aceita: IOption[] = [];

  public operadoras: IOption[] = [];

  constructor(
    private router: Router,
    private _helperService: HelperService,
    private _storeService: StoreService
  ) {
    this.onde_aceita.push({ text: 'No delivery e drive-thru', value: 'A' });
    this.onde_aceita.push({ text: 'Somente delivery', value: 'E' });
    this.onde_aceita.push({ text: 'Somente drive-thru', value: 'L' });

    this.operadoras.push({ text: 'Rede', value: 'rede' });
    this.operadoras.push({ text: 'Cielo', value: 'cielo' });
  }

  ngOnInit(): void {
    this.createFormControls();
    this.createForm();

    this._helperService.getMethodPayments().subscribe((res) => {
      if (res['success']) {
        this.tipos_meio_pagamento = res['method_payments'];
      }
    });

    this.getPaymentMethodsConfig();
  }

  getPaymentMethodsConfig() {
    this.loading = true;
    this._storeService.getMethodPayments().subscribe((res) => {
      this.resMethodPayments(res);
      this.loading = false;
    });
  }

  resMethodPayments(res) {
    if (res['success']) {
      this.pagamento_local.setValue(res['payment_drivethru'] == 'S');
      this.pagamento_entrega.setValue(res['payment_delivery'] == 'S');
      this.pagamento_online.setValue(res['payment_online'] == 'S');

      if (res['system_payment']) {
        let system_payment = res['system_payment'];

        this.tipo.setValue(system_payment['tipo']);
        this.code.setValue(system_payment['code']);
        this.token.setValue(system_payment['token']);
        this.limite_parcelamento_loja.setValue(
          system_payment['limite_parcelamento_loja']
        );
        this.juro_parcelamento_loja.setValue(
          system_payment['juro_parcelamento_loja']
        );
        this.limite_parcelamento_operadora.setValue(
          system_payment['limite_parcelamento_operadora']
        );
        this.juro_parcelamento_operadora.setValue(
          system_payment['juro_parcelamento_operadora']
        );

        this.parecela_minima.setValue(system_payment['parecela_minima']);
      }

      this.payment_methods.clear();
      if (res['method_payments']) {
        for (let i in res['method_payments']) {
          this.onAddNewPaymentMethods(res['method_payments'][i]);
        }
      }
    }
  }

  createFormControls() {
    this.pagamento_local = new FormControl(false);
    this.pagamento_entrega = new FormControl(false);
    this.pagamento_online = new FormControl(false);

    this.tipo = new FormControl(null);
    this.code = new FormControl('');
    this.token = new FormControl('');
    this.limite_parcelamento_loja = new FormControl(null);
    this.juro_parcelamento_loja = new FormControl(null);
    this.limite_parcelamento_operadora = new FormControl(null);
    this.juro_parcelamento_operadora = new FormControl(null);

    this.parecela_minima = new FormControl(null);

    this.payment_methods = new FormArray([]);
  }

  createForm() {
    this.settingsFrm = new FormGroup({
      pagamento_local: this.pagamento_local,
      pagamento_entrega: this.pagamento_entrega,
      pagamento_online: this.pagamento_online,
      payment_methods: this.payment_methods,
      tipo: this.tipo,
      code: this.code,
      token: this.token,
      limite_parcelamento_loja: this.limite_parcelamento_loja,
      juro_parcelamento_loja: this.juro_parcelamento_loja,
      limite_parcelamento_operadora: this.limite_parcelamento_operadora,
      juro_parcelamento_operadora: this.juro_parcelamento_operadora,
      parecela_minima: this.parecela_minima,
    });
  }

  onChangeDetail() {
    this.changed = true;
  }

  onRemovePaymentMethods(i) {
    Swal.fire({
      title: 'Você deseja remover este meio de pagamento?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        let fGroup = <FormGroup>this.payment_methods.controls[i];
        let card_id = <FormControl>fGroup.controls.card_id;

        card_id.setValue(-1);
        this.onChangeDetail();
      }
    });
  }

  onAddNewPaymentMethods(obj) {
    this.payment_methods.push(
      new FormGroup({
        id: new FormControl(obj != undefined && obj.id ? obj.id : null),
        card_id: new FormControl(
          obj != undefined && obj.card_id ? obj.card_id : null
        ),
        accepted: new FormControl(
          obj != undefined && obj.accepted ? obj.accepted : null
        ),
      })
    );
  }

  onCancel() {
    Swal.fire({
      title: 'Você deseja cancelar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.changed = false;
        this.getPaymentMethodsConfig();
      }
    });
  }

  saveError() {
    Swal.fire('Ops!', 'Ocorreu um erro ao tentar salvar.', 'error');
  }

  saveComplete() {
    Swal.fire('Salvo!', 'Os parâmetros do site foram salvos', 'success');
  }

  saving() {
    Swal.fire({
      title: 'Salvando...',
      icon: 'info',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }

  onSubmit() {
    this.saving();

    let data = {
      payment_drivethru: this.pagamento_local.value ? 'S' : 'N',
      payment_delivery: this.pagamento_entrega.value ? 'S' : 'N',
      payment_online: this.pagamento_online.value ? 'S' : 'N',
    };

    let method_payments = [];
    for (let i in this.payment_methods.controls) {
      let fGroup = <FormGroup>this.payment_methods.controls[i];

      let id = <FormControl>fGroup.controls.id;
      let card_id = <FormControl>fGroup.controls.card_id;
      let accepted = <FormControl>fGroup.controls.accepted;

      method_payments.push([id.value, card_id.value, accepted.value]);
    }
    data['method_payments'] = method_payments;

    if (this.tipo.value != '') {
      let system_payment = {
        tipo: this.tipo.value,
        code: this.code.value,
        token: this.token.value,
        limite_parcelamento_loja: this.limite_parcelamento_loja.value,
        juro_parcelamento_loja: this.juro_parcelamento_loja.value,
        limite_parcelamento_operadora: this.limite_parcelamento_operadora.value,
        juro_parcelamento_operadora: this.juro_parcelamento_operadora.value,
        parecela_minima: this.parecela_minima.value,
      };

      data['system_payment'] = system_payment;
    }

    this.saving();

    this._storeService.storeMethodPayments(data).subscribe((res) => {
      if (res['success']) {
        //
        this.resMethodPayments(res);
        //
        this.changed = false;
        //
        this.saveComplete();
      } else {
        this.saveError();
      }
    });

    return null;
  }
}
